<ycn-modal-base
    [extraModalClasses]="'modal-sm'"
    [open]="modalOpen"
    (closeModalHandler)="submit(false)">
    <ycn-simple-modal-header
        [header]="confirmHeader"
        (closeModalHandler)="submit(false)">
    </ycn-simple-modal-header>
    <div class="modal-body">
        <div class="modal-section">
            <div class="modal-message {{confirmTextClass}}" [innerHTML]="sanitizedText"></div>
        </div>
    </div>
    <ycn-simple-modal-footer [attr.data-test-id]="modalTestId ? modalTestId + '-footer' : confirmButtonText + '-footer'"
        [cancelButtonText]="cancelButtonText"
        [submitButtonText]="confirmButtonText"
        [submitButtonClasses]="confirmButtonClasses"
        [showCancelButton]="showCancelButton"
        [showSubmitButton]="showConfirmButton"
        [modalTestId]="modalTestId"
        (cancelHandler)="submit(false)"
        (submitHandler)="submit(true)">
    </ycn-simple-modal-footer>
</ycn-modal-base>
